import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import '../css/InstallShortcut.css';

function InstallShortcut() {
  const location = useLocation();
  const [installPrompt, setInstallPrompt] = useState(null);
  const [showIOSGuide, setShowIOSGuide] = useState(false);
  const agent = navigator.userAgent || '';
  const isIOS = /iPhone|iPad|iPod/i.test(agent);
  const isAndroid = /Android/i.test(agent);
  const isStandalone = window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone === true;

  useEffect(() => {
    const capturePrompt = event => { event.preventDefault(); setInstallPrompt(event); };
    const installed = () => setInstallPrompt(null);
    window.addEventListener('beforeinstallprompt', capturePrompt);
    window.addEventListener('appinstalled', installed);
    return () => {
      window.removeEventListener('beforeinstallprompt', capturePrompt);
      window.removeEventListener('appinstalled', installed);
    };
  }, []);

  // แสดงคำแนะนำติดตั้งเฉพาะหน้า Login เท่านั้น หลัง Login จะไม่รบกวนหน้าการใช้งาน
  if (location.pathname !== '/' || isStandalone || (!isAndroid && !isIOS)) return null;

  const install = async () => {
    if (isIOS) { setShowIOSGuide(true); return; }
    if (installPrompt) {
      await installPrompt.prompt();
      await installPrompt.userChoice;
      setInstallPrompt(null);
      return;
    }
    window.alert('เปิดเมนู ⋮ ของ Chrome แล้วเลือก “ติดตั้งแอป” หรือ “เพิ่มไปยังหน้าจอหลัก”');
  };

  return <>
    <button type="button" className="install-shortcut-button" onClick={install}>📲 เพิ่มแอปไว้หน้าจอมือถือ</button>
    {showIOSGuide && <div className="install-shortcut-backdrop" role="dialog" aria-modal="true"><div><button type="button" onClick={() => setShowIOSGuide(false)}>×</button><span>📲</span><h2>เพิ่มแอปลงหน้าจอ iPhone/iPad</h2><ol><li>เปิดหน้านี้ด้วย <b>Safari</b></li><li>กดปุ่ม <b>Share</b> รูปสี่เหลี่ยมมีลูกศรชี้ขึ้น</li><li>เลือก <b>Add to Home Screen</b></li><li>กด <b>Add</b> เพื่อสร้างไอคอน</li></ol><small>iOS ไม่อนุญาตให้เว็บไซต์ติดตั้งอัตโนมัติ ต้องยืนยันผ่านเมนู Share</small></div></div>}
  </>;
}

export default InstallShortcut;
